"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = require("./cache");
exports.default = (function (callback) {
    if (!callback)
        return;
    if (typeof callback !== 'function') {
        throw new Error('registerAppEnter must be function.');
    }
    cache_1.setCache('appEnter', callback);
});
